const baseUrl = 'https://www.sub2u.com/api'
// const baseUrl = 'https://subway.forecepts.net/api'
// const baseUrl = 'http://192.168.3.250/'

const home = '/Home/GetHomeInfos'
const faq = '/Faq/GetFaqs'
const contactUs = '/Common/ContactUs'
const address = 'https://www.onemap.gov.sg/api/common/elastic/search'

const login = '/Account/Login'
const signup = '/Account/SignUp'
const register = '/Account/Register'
const forgotPassword = '/Account/ForgotPassword'
const forgotPasswordCheck = '/Account/ForgotPasswordCheckValidateCode'
const resendEmail = '/Account/RegisterReSendEmail'
const validateCode = '/Account/CheckValidateCode'
const logout = '/Account/Logout'
const category = '/Category/GetCategories'
const outlet = '/Outlet/GetOutlets'
const product = '/Product/GetProducts'
const productDetail = '/Product/GetProductDetail'

const carts = '/Cart/GetCartDetail'
const cartPreAdd = '/Cart/PreAdd'
const cartAddNew = '/Cart/AddNew'
const cartAdd = '/Cart/Add'
const cartRemove = '/Cart/Remove'
const cartEdit = '/Cart/Edit'
const cartCheckout = '/Cart/Checkout'
const cartChangeDelivery = '/Cart/ChangeDeliveryType'

const orderCheckoutInfo = '/Order/GetCheckoutInfo'
const orderDetail = '/Order/GetOrderDetail'
const orderApplyVoucher = '/Order/ApplyVoucher'
const orderComplete = '/Order/CompleteOrder'
const orderThankyou = '/Order/GetThankYou'
const orderGetPaging = '/Order/GetOrdersPaging'
const orderRemove = '/Order/RemoveOrder'
const orderUpdateDelivery = '/Order/ChangeDeliveryDate'

const customerAddresses = '/Customer/GetAddresses'
const customerAddAddress = '/Customer/AddAddress'
const customerEditAddress = '/Customer/EditAddress'
const customerRemoveAddress = '/Customer/RemoveAddress'
const customerGetInfo = '/Customer/GetCustomerInfo'
const customerEditInfo = '/Customer/EditCustomerInfo'
const customerEditPassword = '/Customer/ChanagePassword'
const customerCredit = '/Customer/GetMyCredit'
const customerPointsPaging = '/Customer/GetPointsPaging'

export default {
  baseUrl,
  home,
  faq,
  contactUs,
  address,
  login,
  signup,
  resendEmail,
  validateCode,
  logout,
  register,
  forgotPassword,
  forgotPasswordCheck,
  category,
  outlet,
  // product
  product,
  productDetail,
  // cart
  carts,
  cartPreAdd,
  cartAddNew,
  cartAdd,
  cartRemove,
  cartEdit,
  cartCheckout,
  cartChangeDelivery,
  // customer
  customerAddresses,
  customerAddAddress,
  customerEditAddress,
  customerRemoveAddress,
  customerGetInfo,
  customerEditInfo,
  customerEditPassword,
  customerCredit,
  customerPointsPaging,
  // order
  orderCheckoutInfo,
  orderDetail,
  orderApplyVoucher,
  orderComplete,
  orderThankyou,
  orderGetPaging,
  orderRemove,
  orderUpdateDelivery
}



// WEBPACK FOOTER //
// ./src/api/url.js